import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import "./UnAuthorizedPage.scss";
import { useTranslation } from "react-i18next";
export const UnauthorizedPage = ({ waiting }) => {
    const { t: translate } = useTranslation();
    const navigate = useNavigate();
    return (_jsx("div", { className: "content-unauthorize", children: _jsxs("div", { className: "message", children: [_jsx("h1", { children: "Access to this page is restricted" }), _jsx("p", { children: "Your access token appears to be invalid or has expired. Please review your token to ensure its accuracy and validity." })] }) }));
};
